import React, { ReactElement, useEffect, useContext } from 'react';
import { Immutable } from '@wds/utils';
import { StaticContext } from '../../../../StaticContext';
import { useInProductMessagesCountQuery } from './InProductMessagesCount.generated';
import NotificationsIcon from './NotificationsIcon';
import NotificationsSheet from './NotificationsSheet';

export type NotificationsProps = Immutable<{
  showNotifications: boolean;
}> & {
  toggleNotifications(): void;
};

const Notifications = ({
  showNotifications,
  toggleNotifications,
}: NotificationsProps): ReactElement => {
  const { HEADER_EXP = {} } = useContext(StaticContext);
  const pollInterval = HEADER_EXP.inProductMessagesPollingInterval || 0;

  const { data, refetch } = useInProductMessagesCountQuery({
    variables: {
      input: {
        isDeleted: false,
        isRead: false,
      },
    },
    pollInterval: showNotifications ? 0 : pollInterval * 1000,
  });

  useEffect(() => {
    if (!showNotifications) {
      refetch();
    }
  }, [refetch, showNotifications]);

  const notificationsCount = data?.inProductMessagesCount?.totalCount ?? 0;

  return (
    <>
      <NotificationsIcon
        unreadNotificationsCount={notificationsCount}
        toggleNotifications={toggleNotifications}
        showNotifications={showNotifications}
      />
      <NotificationsSheet
        unreadNotificationsCount={notificationsCount}
        toggleNotifications={toggleNotifications}
        showNotifications={showNotifications}
      />
    </>
  );
};

export default Notifications;
export { Notifications };
